import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/pro-solid-svg-icons";
import { Col } from "react-bootstrap";

function CountCard(props) {
  const { label = "Company", Count = 0, icon = faBuilding } = props;
  return (
    <div
      style={{
        background: "white",
        borderRadius: "10px",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        padding: "30px 15px",
        width: "100%",
      }}
    >
      <Col md={4}>
        <div style={{ width: "fit-content" }}>
          <div
            style={{
              borderRadius: "50%",
              backgroundColor: "rgba(91, 147, 255, 0.2)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
              color: "#5B93FF",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
      </Col>
      <Col md={8}>
        <div style={{ fontWeight: "500", fontSize: "22px" }}>{Count}</div>
        <div style={{ fontSize: "14px" }}>{label}</div>
      </Col>
    </div>
  );
}

export default CountCard;
